<template>
	<div class="container__registers">
		<ContentHeader>
			<SubHeader :title="title">
				<template #main>
					<SubHeaderButtons
						:active-route="activeRoute"
						:change-route="changeRoute"
						:label-and-link-name="labelAndLinkName"
					/>
				</template>
			</SubHeader>
		</ContentHeader>
		<ContentBody>
			<Card>
				<router-view />
			</Card>
		</ContentBody>
	</div>
</template>

<script>
import SubHeaderButtons from '../../../components/SubHeaderButtons/SubHeaderButtons'
import Card from '../../../components/Card/Card'
import ContentBody from '../../../components/ContentBody/ContentBody'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import SubHeader from '../../../components/SubHeader/SubHeader'

export default {
	components: { Card, ContentBody, ContentHeader, SubHeader, SubHeaderButtons },
	data: () => {
		return {
			activeRoute: '',
		}
	},
	computed: {
		title() {
			return this.activeRoute
		},
		label() {
			return this.labelAndLinkName.filter((f) => f.linkName === this.activeRoute)[0].label
		},
		labelAndLinkName() {
			return [
				{
					label: this.$t('treeCategory'),
					linkName: `${this.$t('registry')} / ${this.$t('inventory')} / ${this.$t('treeCategory')}`,
				},
				{
					label: this.$t('fitoCategory'),
					linkName: `${this.$t('registry')} / ${this.$t('inventory')} / ${this.$t('fitoCategory')}`,
				},
				{
					label: this.$t('product'),
					linkName: `${this.$t('registry')} / ${this.$t('inventory')} / ${this.$t('product')}`,
				},
				{
					label: this.$t('forestStratification'),
					linkName: `${this.$t('registry')} / ${this.$t('inventory')} / ${this.$t('forestStratification')}`,
				},
				{
					label: `${this.$t('measurement')}`,
					linkName: `${this.$t('registry')} / ${this.$t('inventory')} / ${this.$t('measurement')}`,
				},
				{
					label: this.$t('plot'),
					linkName: `${this.$t('registry')} / ${this.$t('inventory')} / ${this.$t('plot')}`,
				},
				{
					label: `${this.$t('logging')}`,
					linkName: `${this.$t('registry')} / ${this.$t('inventory')} / ${this.$t('logging')}`,
				},
			]
		},
	},

	watch: {
		$route(to) {
			this.activeRoute = to.name
		},
	},
	created() {
		this.activeRoute = this.$route.name
	},

	methods: {
		changeRoute(linkName) {
			if (this.$route.name !== linkName) {
				this.$router.push({ name: linkName })
			}
		},
	},
}
</script>

<style scoped></style>
